import { validateRule } from "./validateRule";
import { createSchemaValidator } from "./createSchemaValidator";

export const validateSchema = createSchemaValidator(validateRule);
